// @owners { team: patients }
import { useCallback } from 'react';
// eslint-disable-next-line import/no-deprecated
import { fetchDeliveries } from '~shared/actions/deliveries';
// eslint-disable-next-line import/no-deprecated
import { fetchPrescriptionPricing } from '~shared/actions/pricing';
import getIsAuthorized from '~shared/selectors/auth/getIsAuthorized';
import { type ReduxDispatchShared } from '~shared/types';
import { type configureStore } from '~web/configureStore';

type WebReduxStore = ReturnType<typeof configureStore>['store'];

/**
 * Fetches initial data (deliveries and prescription pricing)
 * Note: the redux store is passed into this hook because the redux provider
 * is rendered in PatientDashboardApp. This allows populating the redux state
 * and dispatching network request actions.
 * @returns
 */
export const useGetInitialData = ({ store }: { store: WebReduxStore }) => {
  const getInitialData = useCallback(async () => {
    const initialState = store.getState();
    const isAuthorized = getIsAuthorized(initialState);
    if (!isAuthorized) return;

    const dispatch = store.dispatch as ReduxDispatchShared;
    await Promise.all([
      // eslint-disable-next-line import/no-deprecated
      dispatch(fetchDeliveries()),
      // eslint-disable-next-line import/no-deprecated
      dispatch(fetchPrescriptionPricing()),
    ]);
  }, [store]);

  return { getInitialData };
};
